<template>
  <div class="album-box">
    <div v-if="serviceType != 'None Type'">
      <div class="box1">
        <div class="item">
          <div class="title">Shooting with DANIEL LOEB</div>
          <div class="text" v-text="shootingDate"></div>
        </div>
      </div>

      <div class="message-box">
        <div class="upload-images">
          <div
            class="item-image"
            v-for="(item, index) in uploadImages"
            :key="index"
          >
            <img :src="item" />
          </div>
        </div>
        <div class="buttons">
          <base-button-type-1
            text="ALBUM"
            @click="buttonAction"
            color-type="white"
          ></base-button-type-1>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <div class="message">There is no service</div>
    </div>
  </div>
</template>

<script>
import BaseButtonType1 from './form-elemnets/BaseButtonType1'
export default {
  name: 'album-box',
  components: { BaseButtonType1 },
  props: {
    uploadImages: {
      default: () => [
        require('../../assets/images/error/error.jpg'),
        require('../../assets/images/error/error.jpg'),
        require('../../assets/images/error/error.jpg'),
        require('../../assets/images/error/error.jpg')
      ],
      type: Array
    },
    photographerName: {
      default: 'DANIEL LOEB',
      type: String
    },
    shootingDate: {
      default: '@/components/2017',
      type: String
    },
    albumId: {
      default: 1,
      type: Number
    }
  },
  created() {
    // console.log(this.portfolioImages)
  },
  methods: {
    buttonAction() {
      this.$router.push({
        path: 'album/detail',
        query: { albumId: this.albumId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.album-box {
  border: 1px solid #c8c8c8;
  .box1 {
    background-color: #f5f5f5;
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    .item {
      width: 100%;
      height: 80px;

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
      }
    }
  }
  .message-box {
    height: 233px;
    display: flex;
    justify-content: space-between;
    .upload-images {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 7px;
      .item-image {
        margin-left: 24px;
        width: 123px;
        height: 184px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          object-fit: contain;
          width: 100%;
          height: auto;
        }
      }
    }

    .contents {
      width: 70%;
      margin: 18px 0 18px 0;
      /*border: 1px dotted red;*/
      .author {
        font-weight: 600;
      }

      .comment {
        margin: 10px 0 0 0;
        width: 700px;
        height: 71px;
        /*border: 1px solid red;*/
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .buttons {
      width: 200px;
      /*border: 1px dotted green;*/
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      align-items: center;
      padding-bottom: 30px;
    }
  }
  .no-data {
    height: 233px;
    position: relative;
    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }
    background-color: #f5f5f5;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
  }
}
</style>
